var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetUnknownLogo = function SvgAssetUnknownLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#asset-unknown-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000636",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.79 18.797q.015-.93.21-1.469.195-.54.797-1.195l1.023-1.055q.657-.742.657-1.594 0-.82-.43-1.28-.43-.47-1.25-.47-.797 0-1.281.422-.485.422-.485 1.133h-1.445q.016-1.265.898-2.039.891-.78 2.313-.781 1.476 0 2.297.797.828.789.828 2.172 0 1.367-1.266 2.695l-.851.844q-.57.632-.57 1.82zm-.063 2.476q0-.352.21-.585.22-.243.641-.243t.64.242a.83.83 0 0 1 .22.586q0 .352-.22.586-.218.227-.64.227t-.64-.227a.84.84 0 0 1-.211-.586"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "asset-unknown-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgAssetUnknownLogo;